import React from "react";
import { useState, useEffect, useContext } from "react";
import ButtonSubmit from "../buttonSubmit";
import {
  CONST_GENDER_MALE,
  CONST_GENDER_FEMALE,
  isValidGender,
  simplyClick,
} from "../../helpers";
import "./GenderForm.scss";
import ProgressDots from "../ProgressDots/ProgressDots";
import { ContextProfileUser } from "../../lib/profileContext";

function GenderForm({ nextStep }) {
  const [errorGender, setErrorGender] = useState(null);
  const { data, setData } = useContext(ContextProfileUser);
  const [hasClickedSelect, setHasClickedSelect] = useState(false);

  const genderLabel = {
    [CONST_GENDER_MALE]: "Man, looking for a woman",
    [CONST_GENDER_FEMALE]: "Woman, looking for a man",
  };

  const genderKey = {
    [CONST_GENDER_MALE]: "man_looking_woman",
    [CONST_GENDER_FEMALE]: "woman_looking_man",
  };

  const handlerSubmit = (event) => {
    event.preventDefault();

    if (!hasClickedSelect) {
      simplyClick("cl_lnd_i_am_choose", { text: genderKey[CONST_GENDER_MALE] });
    }

    if (!isValidGender(data.gender)) {
      setErrorGender("Please, choose your gender ");
    } else {
      simplyClick("cl_lnd_i_am_next");
      nextStep();
    }
  };

  const [choiceGender, setChoiceGender] = useState(CONST_GENDER_MALE);

  const handleAddTypeGender = ({ target: { value } }) => {
    const genderValue = Number(value);
    setData({ ...data, gender: genderValue });
    setChoiceGender(genderValue);
    simplyClick("cl_lnd_i_am_choose", { text: genderKey[genderValue] });
    setHasClickedSelect(true);
  };

  useEffect(() => {
    setData({ ...data, gender: CONST_GENDER_MALE });
  }, []);

  const options = Object.keys(genderLabel).map((key, index) => (
    <option value={key} key={`${key}_${index}`}>
      {genderLabel[key]}
    </option>
  ));

  return (
    <div className="promo__wrapper-gender">
      <form className="gender__form" onSubmit={handlerSubmit}>
        <div className="user__form-top">
          <h3>I am a</h3>
        </div>
        <div className="gender__form-content">
          <div className="custom-select gender">
            <div className="custom-select-me">
              <select
                onChange={handleAddTypeGender}
                className="gender"
                value={choiceGender}
              >
                {options}
              </select>
            </div>
          </div>
          {errorGender && <p className="error">{errorGender}</p>}
          <ButtonSubmit
            className={"button__global button__gender"}
            text={"NEXT"}
          />
          <ProgressDots total={6} activeCount={2} />
        </div>
      </form>
    </div>
  );
}

export default GenderForm;
